import { Page } from '@/components';
import { useApi, SKY_API_ENDPOINT } from '@/api';
import { Flex, KpiSkeleton } from '@blockanalitica/ui';
import { KpiCard, InfoTooltip } from '@/components';
import { useParams } from 'react-router-dom';

import StarRequiredRiskCapitalTable from './StarRequiredRiskCapitalTable';

export default function StarRequiredRiskCapitalPage() {
  const { star } = useParams();
  const [data, error] = useApi({
    baseUrl: SKY_API_ENDPOINT,
    url: `/rrc/primes/${star}/`
  });

  if (error) {
    throw error;
  }

  return (
    <Page
      title={
        <Flex gap="xs" alignItems="center">
          <h1>
            {star.charAt(0).toUpperCase() + star.slice(1)} Risk Capital &
            Requirements Monitor
          </h1>
        </Flex>
      }>
      {!data?.data ? (
        <Flex flexDirection="column" gap="s">
          <Flex gap="xs" flexDirection={['column', 'row']}>
            <KpiSkeleton />
            <KpiSkeleton />
            <KpiSkeleton />
          </Flex>
          <Flex gap="xs">
            <KpiSkeleton />
            <KpiSkeleton />
          </Flex>
        </Flex>
      ) : (
        <>
          <Flex gap="xs" flexDirection={['column', 'row']}>
            <KpiCard
              title="Total Exposure"
              data={data.data}
              field="total_exposure"
              options={{ currency: 'USD', notation: 'compact' }}
            />
            <KpiCard
              title="Total RRC"
              data={data.data}
              field="total_rrc"
              options={{ currency: 'USD', notation: 'compact' }}
            />
            <KpiCard
              title="% of Exposure"
              data={data.data}
              field="total_exposure_share"
              options={{
                percentage: true,
                variants: {
                  valuePercentageValue: 'dynamic'
                }
              }}
            />
          </Flex>
          <Flex gap="xs">
            <KpiCard
              title={
                <Flex gap="3xs">
                  Total Risk Capital
                  <InfoTooltip text="Star Agent's treasury assets held in its SubProxy (internal Junior Risk Capital)." />
                </Flex>
              }
              data={data.data}
              field="total_rc"
              options={{ currency: 'USD', notation: 'compact' }}
            />
            <KpiCard
              title="Encumbrance Ratio"
              data={data.data}
              field="encumbrance_ratio"
              options={{
                percentage: true,
                variants: {
                  valuePercentageValue: 'dynamic'
                }
              }}
            />
          </Flex>
        </>
      )}
      <StarRequiredRiskCapitalTable star={star} />
    </Page>
  );
}
